<script setup>
import AppCard from './ui/AppCard.vue'
import Skeleton from './ui/Skeleton.vue'
</script>

<template>
  <AppCard class="lottery-skeleton-card">
    <Skeleton class="line title" />
    <div class="status-row">
      <Skeleton class="badge" />
      <Skeleton class="deadline" />
    </div>
    <Skeleton class="line" />
    <div class="actions">
      <Skeleton class="button" />
    </div>
  </AppCard>
</template>

<style scoped>
.line {
  height: 14px;
}

.title {
  width: 72%;
  height: 18px;
  margin-bottom: 12px;
}

.status-row {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}

.badge {
  width: 72px;
  height: 22px;
  border-radius: 999px;
}

.deadline {
  width: 140px;
  height: 12px;
}

.actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.button {
  height: 36px;
  width: 112px;
}
</style>

